import { render, staticRenderFns } from "./InputStorageRequest.vue?vue&type=template&id=82d987cc"
import script from "./InputStorageRequest.vue?vue&type=script&lang=js"
export * from "./InputStorageRequest.vue?vue&type=script&lang=js"
import style0 from "./InputStorageRequest.vue?vue&type=style&index=0&id=82d987cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports